<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="cancel()">
        Close
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="video-modal-body">
    <ion-card-header class="ion-text-center">
      <ion-card-title>{{ video.title }}</ion-card-title>
    </ion-card-header>
    <ion-card>
      <iframe texttrack="EN" (load)="iframeLoaded()" id="iframe-video" mozallowfullscreen="true" webkitallowfullscreen="true" allowfullscreen="true" [src]="vimeolink" [width]="vimeowidth()" [height]="vimeoheight()" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
    </ion-card>
    <app-video-instructions [videoWidth]="vimeowidth()"></app-video-instructions>
    <div class="ajax-request-loader" *ngIf="showAjaxRequestLoader == true">
        <ion-spinner name="crescent" *ngIf="showSpinnerLoader == true"></ion-spinner>
    </div>
  </div>
</ion-content>
